module.exports = __webpack_public_path__ + "components/app-promo/static/de/snow-forecast__app-screenshot--6-2a90084076da68eb27711ce0a3871ad6.jpg";